import IpsTable from './IpsTable.vue';

export default IpsTable;
